// extracted by mini-css-extract-plugin
export default {"caixona":"item_caixona__lGy1+","imagem":"item_imagem__yaoPq"};